import { registerCrudStore } from '@/libs/core/+state/register-crud-store';
import { CycleTimeModel } from '@/libs/Api';
import { CycleTimesDataService } from '@/libs/cycle-times/cycle-times-data-service';
import { BusinessModule } from '@/libs/core/models/business-module';

export const cycleTimesStore = registerCrudStore<CycleTimeModel, CycleTimeModel>(
    BusinessModule.CycleTime,
    new CycleTimesDataService()
);
